var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { BUTTON_SUPPORT, GENERIC_ERROR_MESSAGE, GENERIC_ERROR_TITLE, MAIL_SUPPORT, } from 'src/constants/strings';
import { StruggleIcon } from '../assets/icons/struggle';
import { Box, ErrorWidget, Spinner } from '../components';
import useDynamicScript from '../hooks/useDynamicScript';
// TODO: AP: reduce anys
function loadComponent(scope, module) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var container, factory, Module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Initializes the share scope. This fills it with known provided modules from this build and all remotes
                return [4 /*yield*/, __webpack_init_sharing__('default')];
                case 1:
                    // Initializes the share scope. This fills it with known provided modules from this build and all remotes
                    _a.sent();
                    container = window[scope];
                    // Initialize the container, it may provide shared modules
                    return [4 /*yield*/, container.init(__webpack_share_scopes__.default)];
                case 2:
                    // Initialize the container, it may provide shared modules
                    _a.sent();
                    return [4 /*yield*/, window[scope].get(module)];
                case 3:
                    factory = _a.sent();
                    Module = factory();
                    return [2 /*return*/, Module];
            }
        });
    }); };
}
function ModuleLoader(_a) {
    var module = _a.module, url = _a.url, scope = _a.scope, props = _a.props;
    var _b = useDynamicScript({
        url: module && url,
    }), ready = _b.ready, failed = _b.failed;
    if (!module) {
        return _jsx("h2", { children: "Not system specified" });
    }
    if (!ready) {
        return _jsx(Spinner, {});
    }
    if (failed) {
        return (_jsx(Box, __assign({ h: "50vh", d: "flex", alignItems: "center", justifyContent: "center" }, { children: _jsx(ErrorWidget, { title: GENERIC_ERROR_TITLE, message: GENERIC_ERROR_MESSAGE, text: BUTTON_SUPPORT, icon: _jsx(StruggleIcon, {}), url: MAIL_SUPPORT }) })));
    }
    var Component = React.lazy(loadComponent(scope, module));
    return (_jsx(Suspense, __assign({ fallback: _jsx(Spinner, {}) }, { children: _jsx(Component, __assign({}, props)) })));
}
export default ModuleLoader;
